import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

/**
 * Guard for routes that should only be accessible when the user is not authenticated.
 * If the user is not authenticated, allows access to the route.
 * If the user is authenticated, redirects to the main screen of the app.
 */
export const noAuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.check().pipe(
    map(authenticated => {
      if (!authenticated) {
        return true;
      } else {
        return router.createUrlTree(['']);
      }
    })
  );
};